import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  backBtn: {
    id: 'WhfZpn',
    defaultMessage: 'Back',
    description: 'Back button to go to previous step',
  },
  startImportBtn: {
    id: 'Uu0xP0',
    defaultMessage: 'Start Import',
    description: 'Button to start import',
  },
});
